import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
	topOverlay: {
		position: 'absolute',
		backgroundColor: 'rgba(0, 0, 0, 0.2)',
		top: 0,
		left: 0,
		zIndex: 2
	},
	leftOverlay: {
		position: 'absolute',
		backgroundColor: 'rgba(0, 205, 0, 0.2)',
		left: 0,
		top: 0,
		zIndex: 2
	},
	rightOverlay: {
		position: 'absolute',
		backgroundColor: 'rgba(0, 0, 255, 0.2)',
		right: 0,
		top: 0,
		zIndex: 2
	},
	overlayClickBlockerPreview: {
		flexWrap: 'wrap',
		justifyContent: 'space-around',
		overflow: 'hidden'
	},
	playerPreviewBox: {
		position: 'relative',
		backgroundColor: '#e0e0e0',
		margin: '0 auto',
		border: '.2rem solid',
		borderColor: '#000'
	}
}));
